var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"with-hero-image"},[(_vm.image)?_c('div',{class:[
      'with-hero-image__wrapper',
      { 'with-hero-image__wrapper--fixed': _vm.fixed && _vm.forceFixed },
      { 'with-hero-image__wrapper--clickable': _vm.clickable },
      {
        'with-hero-image__wrapper--clickable--fullsize':
          _vm.fullsize || _vm.forceFullsize,
      } ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{class:[
        'with-hero-image__image',
        { 'with-hero-image__image--fullsize': _vm.fullsize || _vm.forceFullsize },
        { 'with-hero-image__image--center': _vm.center } ],style:({ backgroundImage: ("url(" + _vm.image + ")") })})]):_vm._e(),_c('div',{class:{ 'with-hero-image__page': _vm.image }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }